import { getOwnConfig, macroCondition } from '@embroider/macros';
import EmbroiderRouter from '@embroider/router';
import config from 'walden-trace-app/config/environment';
import type { OwnBuildConfig } from 'walden-trace-app/types';

export default class Router extends EmbroiderRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  this.route('not-found', { path: '/*path' });

  this.route('app', { path: '/' }, function () {
    this.route('shipments', function () {
      this.route('detail', { path: '/:shipment_id' });
      this.route('filters');
    });
    this.route('user-settings');
    this.route('help');
  });

  this.route('privacy-policy');
  this.route('login');
  this.route('auth-callback');
  this.route('unauthorized');

  if (macroCondition(getOwnConfig<OwnBuildConfig>().styleGuideIncluded)) {
    this.route('style-guide');
  }
});
